if (!window._slideshowSliderLoaded) {
  window._slideshowSliderLoaded = true;

  class slideshowSlider {
    constructor(parent) {
      if (parent.length == 0) {
        return;
      }
      this.parent = parent;
      this.init();
      this.clickEvent();
    }

    init = () =>{
      const elements = qsa('.slideshow-component-js');
      elements.forEach((item)=>{
        this.swiper(item)
      })
    }

    swiper = (element) => {
      let elId = element.getAttribute("data-id");
      let loop = element.getAttribute("data-loop") == "true" ? true : false;
      let autoplay = element.getAttribute("data-autoplay") == "true" ? true : false;
      let time = parseInt(element.getAttribute("data-autoplay-delay")) * 1000;
      let navigation = element.getAttribute("data-arrow") == "true" ? true : false;
      let pagination = element.getAttribute("data-pagination") == "true" ? true : false;

      if (navigation) {
          navigation = {
            nextEl: `.${elId} .swiper-button-next`,
            prevEl: `.${elId} .swiper-button-prev`,
          };
        }

        if (pagination) {
          pagination = {
            el: `.${elId} .swiper-pagination`,
            clickable: true,
          };
        }

        if (autoplay) {
          autoplay = {
            delay: time,
            disableOnInteraction: false
          };
        }

      let swiper = new Swiper(element, {
        loop,
        autoplay,
        pagination,
        navigation,
      });
    };

    clickEvent = () => {
      let parents = this.parent;
      parents.forEach(parent => {
        let playPauseButton = parent.querySelectorAll('.video-pause-floating');
        playPauseButton.forEach(element => {
          element.addEventListener("click", (e) => {
            let that = e.currentTarget;
            let slideWrapper = that.closest(".slideshow-video__video-wrapper");
            let videos = slideWrapper.querySelectorAll(".slideshow-video__video");
            videos.forEach(video => {
              if(that.title == 'Pause') {
                video.pause();
              }else {
                video.play();
              };
            });

            if(that.title == 'Pause') {
              that.title = 'Play';
              that.dataset.isPlaying = "false";
            }else {
              that.title = 'Pause';
              that.dataset.isPlaying = "true";
            }
          })
        });
      });
    }
  }

  new slideshowSlider(document.querySelectorAll('.section-slideshow'));
}